// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"636":"054a54030998d22c","1836":"0280bd8a449c810a","5735":"beb578cc985d134d"}[chunkId] + ".css";
};